// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xdqH5","rootMobile":"styles_rootMobile__SNUfm"};